import axios from "axios";

export const authHeaders = () => {
  const authToken = localStorage.getItem("auth-token");
  return {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
};

// export const authHeaders = () => {
//   const authToken =
//     localStorage.getItem("userData") &&
//     JSON.parse(localStorage.getItem("userData")).token;
//   return {
//     headers: {
//       Authorization: `Bearer ${authToken}`,
//     },
//   };
// };


export const formAuthHeaders = () => {
  const authToken =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData")).token;
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${authToken}`,
    },
    
  };
};

// console.log("authHeaders",process.env.REACT_APP_BASE_URL);

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  withCredentials: true,
});

Axios.interceptors.response.use(
  (response) => {
    // console.log("Interceptor Response ::: ", response);
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getProxiedImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("blob:") || url.startsWith("data:")) return url;
  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3010/api/v1/admin";
  return `${baseUrl}/maps/map-files/proxy-image?url=${encodeURIComponent(url)}`;
};

export default Axios;


